import { useQuery } from '@tanstack/react-query'
import { getFeed } from '../services/api'
import { PageShell } from '../components/page/PageShell'
import { NyhedCard } from '../components/feed/NyhedCard'

function NyhederPage() {
  const { data: feed, isLoading, error } = useQuery({
    queryKey: ['feed', 'full'],
    queryFn: () => getFeed(30),
    retry: 2,
  })

  const newProducts = feed?.new_products || []
  const newReviews = feed?.new_reviews || []
  const updated = feed?.recently_updated || []
  const hasAny = newProducts.length > 0 || newReviews.length > 0 || updated.length > 0

  if (isLoading) {
    return (
      <PageShell title="Nyheder" intro="Nye produkter, anmeldelser og opdateringer">
        <div className="page-loading">Indlæser nyheder...</div>
      </PageShell>
    )
  }

  if (error) {
    return (
      <PageShell title="Nyheder">
        <div className="page-error">Fejl ved indlæsning: {error.message}</div>
      </PageShell>
    )
  }

  return (
    <PageShell
      backTo="/"
      backLabel="Hjem"
      breadcrumbs={[
        { label: 'Hjem', to: '/' },
        { label: 'Nyheder' },
      ]}
      actions={[
        { label: 'Padel bats', to: '/bat', primary: true },
      ]}
      title="Nyheder"
      intro="Nye produkter, anmeldelser og opdateringer"
    >
      {!hasAny ? (
        <div className="page-empty">Ingen nyheder endnu. Kom tilbage snart.</div>
      ) : (
        <>
          {newProducts.length > 0 && (
            <section className="page-section">
              <h2 className="page-section-title">Nye produkter</h2>
              <div className="nyheder-grid">
                {newProducts.map((p) => (
                  <NyhedCard key={`np-${p.id}`} item={{ type: 'product', product: p }} dateFormat="long" />
                ))}
              </div>
            </section>
          )}

          {newReviews.length > 0 && (
            <section className="page-section">
              <h2 className="page-section-title">Ny anmeldelser</h2>
              <div className="nyheder-grid nyheder-grid--wide">
                {newReviews.map((r) => (
                  <NyhedCard key={`nr-${r.id}`} item={{ type: 'review', ...r }} dateFormat="long" />
                ))}
              </div>
            </section>
          )}

          {updated.length > 0 && (
            <section className="page-section">
              <h2 className="page-section-title">Senest opdateret</h2>
              <div className="nyheder-grid">
                {updated.map((p) => (
                  <NyhedCard key={`ru-${p.id}`} item={{ type: 'updated', product: p }} dateFormat="long" />
                ))}
              </div>
            </section>
          )}
        </>
      )}
    </PageShell>
  )
}

export default NyhederPage
